module.exports = "pegasus_template/assets/circleline-pinterest.gif";